import type { NamePool } from "@/core/types.js";
export const brNamePool: NamePool = {
  given: {
    male: ["Lucas","Gabriel","Matheus","Pedro","Rafael","Felipe","João","Bruno","Diego","Carlos","Marcelo","Eduardo","Roberto","Fernando","Henrique","André","Alexandre","Ricardo","Rodrigo","Paulo"],
    female: ["Ana","Maria","Juliana","Fernanda","Camila","Aline","Amanda","Beatriz","Larissa","Natalia","Patricia","Leticia","Mariana","Vanessa","Carolina","Viviane","Priscila","Cristiane","Renata","Daniela"],
  },
  family: ["Silva","Santos","Oliveira","Souza","Lima","Pereira","Ferreira","Costa","Carvalho","Rodrigues","Alves","Nascimento","Martins","Rocha","Araújo","Ribeiro","Monteiro","Cardoso","Gomes","Castro"],
};
